import { z } from "zod";
const Id = z.number().int().positive();
/** Event type pattern: `<entity>.<action>` with `*` wildcards, e.g. `work_object.*`, `*.deleted`. */
export const EventPattern = z.string().regex(/^[a-z_*]+\.[a-z_:*]+$/, "pattern must look like entity.action, '*' allowed");
export const Webhook = z.object({
    id: Id,
    name: z.string(),
    url: z.url(),
    eventFilter: z.array(EventPattern),
    active: z.boolean(),
    createdBy: Id,
    createdAt: z.coerce.date(),
    updatedAt: z.coerce.date(),
});
/** Returned once at creation: the signing secret. */
export const WebhookCreated = Webhook.extend({ secret: z.string() });
export const CreateWebhookInput = z.object({
    name: z.string().min(1).max(200),
    url: z.url().refine((u) => u.startsWith("https://") || u.startsWith("http://"), "http(s) only"),
    eventFilter: z.array(EventPattern).max(50).default([]),
    active: z.boolean().default(true),
});
export const UpdateWebhookInput = z
    .object({
    name: z.string().min(1).max(200).optional(),
    url: z.url().optional(),
    eventFilter: z.array(EventPattern).max(50).optional(),
    active: z.boolean().optional(),
    /** generate and return a new secret */
    rotateSecret: z.boolean().optional(),
})
    .strict();
export const WebhookDelivery = z.object({
    id: Id,
    webhookId: Id,
    outboxId: Id,
    eventType: z.string(),
    activityId: Id,
    attempts: z.number().int(),
    nextAttemptAt: z.coerce.date(),
    deliveredAt: z.coerce.date().nullable(),
    deadAt: z.coerce.date().nullable(),
    lastStatus: z.number().int().nullable(),
    lastError: z.string().nullable(),
});
/** What a receiver gets. Ids and field names only, never values (design 5). */
export const WebhookEvent = z.object({
    id: Id.describe("outbox id; stable across retries"),
    type: z.string(),
    workspace: z.string(),
    occurredAt: z.coerce.date(),
    activityId: Id,
    batchId: z.uuid(),
    entityKind: z.string(),
    entityId: Id,
    objectId: Id.nullable(),
    action: z.string(),
    fields: z.array(z.string()),
    flags: z.array(z.string()),
    actor: z.object({ kind: z.string(), id: z.number().int().nullable() }),
});
//# sourceMappingURL=webhooks.js.map